<template>
  <div>
    <div class="flex flex-col items-center text-center">
      <CreditCardIcon class="h-9 w-12 text-gray-800" />
      <h2 class="mt-3 text-[18px] font-medium leading-6 text-gray-800">
        Add payment method
      </h2>
      <p class="mt-1.5 text-[14px] leading-5 text-gray-500">
        Verify and complete your card information.
      </p>
    </div>

    <div id="card" class="mt-6" />

    <Alert v-if="errorMessage" variant="error" :icon="AlertIcon" class="mt-3">
      {{ errorMessage }}
    </Alert>
  </div>
</template>

<script setup lang="ts">
import { Alert } from '@dacr/library'
import { CreditCardIcon, AlertIcon } from '@dacr/icons'

defineProps<{ errorMessage: string }>()
</script>
